<div class="snack-bar">
    <mat-icon class="snack-bar__icon" [style]="{ color: data.iconColor }">{{ data.iconName }}</mat-icon>
    <div class="snack-bar__text">{{ data.text }}</div>
    <button (click)="close()" class="snack-bar__close ml-5" *ngIf="data.closable">
        <mat-icon class="snack-bat__close-icon">close</mat-icon>
    </button>
</div>
